export default {
  data() {
    return {
      MAIN_AGENT_CLASS_NAME: "InstructedAgentProd",
      node_broker_cmd: null,
      debug: false,
    };
  },
  methods: {
    base_command() {
      var command = {
        type: "IBInstance",
        command: "NULL",
        data: {},
      };
      return command;
    },
    get_instructed_agent(agents) {
      return agents?.find((a) => a.class_name == this.MAIN_AGENT_CLASS_NAME);
    },
    get_broker_agents() {
      let agents = [];
      if (this.node_broker_cmd?.config_json) {
        if (this.node_broker_cmd?.config_json?.agent_id) {
          let a = {
            id: this.node_broker_cmd.config_json.agent_id,
            class_name: this.MAIN_AGENT_CLASS_NAME,
            name: this.node_broker_cmd.config_json.agent_name,
            status: "--",
            sub_status: "--",
          };
          agents.push(a);
        }
        this.node_broker_cmd.config_json?.user_agents?.forEach((e) => {
          agents.push({ ...e, status: "--", sub_status: "--" });
        });
      }
      return agents;
    },
    async do_instance_command(cmd_type, command, data) {
      if (!this.node_broker_cmd?.config_json?.ib_id) return;
      if (this.debug) console.log("doing do_instance_command");
      var cmd = this.base_command();
      cmd.type = cmd_type;
      cmd.command = command;
      cmd.data = { ...cmd.data, ...data };
      var path = `${this.apip.API_USER_IB_INSTANCE_CONFIG_PATH}/${this.node_broker_cmd.config_json.ib_id}/command`;
      try {
        var response = await this.pyx_api.put(path, cmd);
        if (this.debug) console.log(response);
      } catch (error) {
        this.show_error_message(error);
      }
    },
  },
};
